import {User} from '../../_models/User'
import { toast } from 'react-toastify';

  export function updateUser(this:any, event:any) {
    event.preventDefault()
    let formData = new FormData();
    this.setState({updating: true})
    for (let key in this.state.user) {
      if (this.state.user[key] !== null) {
        let value = this.state.user[key]
        if(typeof(value) == 'object' && value.length > 0) {
          value = JSON.stringify(value)
        }
        formData.append(key, value);
      }
    }

    if (this.picture.files.length > 0) {
      formData.set("picture", this.picture.files[0]);
    }


    formData.append("accountType", window.account.type || "")
    formData.append("accountId", window.account.id || "")
    if(this.state.user.birthDate)
      formData.set("birthDate", this.state.user.birthDate.format("DD/MM/YYYY"));

    //return
    fetch('users/edit', {
      method: 'POST',
      body: formData,
      headers: {
          "Content-Type": "multipart/form-data",
      },
    }).then(results => {
      return results.json();
    }).then(data => {
        let user = new User(data.user)
        let categories = user.categories.map((category:any) => {
          return {value: category.id, label: category.title}
        })
        user.categories = categories
        user.updated = true
        if(!this.state.user.id) {
          //New user, go back
          this.props.history.push("/users")
        } else {
          //It's an update
          this.setState({user, updating: false})
        }
    }).catch(err => {
      this.setState({updating: false})

      toast.error(err.message);
    })


  }

  export function removeUser(this:any, id: number, index: number, event:any) {
    event.preventDefault()
    let confirmed = confirm(this.props.translate("areYouSure").toString())
    if(!confirmed) return
    fetch('users/delete', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(() => {
      let users = this.state.users
      users.splice(index, 1)
      this.setState({users})
    }).catch(err => {
      toast.error(err.message);
    })
  }


  export function handleSelectChange(this:any, selectedOption:any) {
    this.setState({ selectedOption }, () => {
      if(selectedOption.value) {
        let campaign = this.state.campaign
        campaign.updated = false
        this.setState({campaign})
      } else {
        let campaign = this.state.campaign
        campaign.updated = false
        this.setState({campaign})
      }
    });
  }

  export function removeCategory(this:any, id: number, index: number, event:any) {
    event.preventDefault()
    let confirmed = confirm(this.props.translate("areYouSure").toString())
    if(!confirmed) return
    fetch('categories/delete', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(() => {
      let categories = this.state.categories
      categories.splice(index, 1)
      this.setState({categories})
    }).catch(err => {
      toast.error(err.message);
    })
  }


  export function updateCategory(this:any, event:any) {
    event.preventDefault()
    fetch('categories/edit', {
      method: 'POST',
      body: JSON.stringify(this.state.category)
    }).then(results => {
      return results.json();
    }).then(data => {
      let category = data.category
      category.updated = true
      this.setState({category})
      //this.props.history.push("/users/categories")
    }).catch(err => {
      toast.error(err.message);
    })
  }


  export function handleCategoryChange(this:any, event: any) {
    let category = this.state.category
    category[event.target.name] = event.target.value
    category.updated = false
    this.setState({category});
  }

  export function handleUserChange(this:any, event: any) {
    let user = this.state.user
    user[event.target.name] = event.target.value
    user.updated = false
    this.setState({user});
  }

  export function handleCategoriesChange(this: any, categories: any) {
    let user = this.state.user
    user.categories = categories
    user.updated = false
    this.setState({ user });
  };



// WEBPACK FOOTER //
// ./src/pages/user/controller.tsx